import { render, staticRenderFns } from "./PayDialogs.vue?vue&type=template&id=2f53032f"
import script from "./PayDialogs.vue?vue&type=script&lang=js"
export * from "./PayDialogs.vue?vue&type=script&lang=js"
import style0 from "./PayDialogs.vue?vue&type=style&index=0&id=2f53032f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports